import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../../services/general.service';
import { ServicingService } from '../../../../../services/servicing.service';
import { CustomersService } from '../../../../../services/customers.service';
import { ConsultancyService } from '../../../../../services/consultancy.service';


import { exit } from 'process';

declare var $: any;

@Component({
  selector: 'app-language-task',
  templateUrl: './language-task.component.html',
  styleUrls: ['./language-task.component.css']
})

export class ConsultancyLangTaskComponent implements OnInit {

  @Input() ID: string;
  @Input() SID: string;
  @Input() OID: string;
  @Input() CID: string;
  @Input() TID: string;
  @Input() langs: string;
  @Input() tlang: string;

  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  typeConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;
  serviceId: string;
  plan_id: string;
  intervention_id: string;
  lang: any;
  generalLang: any;
  cid: string;
  tid: string;
  record: any;
  app_emp_id: any;
  mode: string;
  data_action: any;

  //common data
  data: any;

  imageLink: any;
  id: number;
  action: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private servicingService: ServicingService,
    private consultancyService: ConsultancyService,

    private customersService: CustomersService,
    private router: Router,
    private route: ActivatedRoute,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {

    this.getData();

    this.config();
    this.fileDesign();


  }



  config(): void {

    // console.log(this.generalLang);


  }

  FormBuild(): void {

    // console.log(this.cid);
    this.createForm = this.formBuilder.group({
      language_id: ['1'],
      consultancy_id: this.cid,
      task_id: this.tid
    });
  }




  documentAttachment(): FormArray {
    return this.createForm.get('documentAttachment') as FormArray;
  };

  service_image_exists(): FormArray {
    return this.createForm.get('service_image_exists') as FormArray;
  };

  newAttachment(): FormGroup {
    return this.formBuilder.group({
      // link: ['', [ValidateExtension(['csv','doc','docx','pptx','txt','pdf','xlsx','xls'])]]
      link: [''],
    });
  }

  addAttachment(): void {
    this.documentAttachment().push(this.newAttachment());
  }

  removeAttachment(i: number) {
    this.documentAttachment().removeAt(i);
  }

  // timetable_link_uploaded(): FormArray {
  // return this.createForm.get('timetable_link_uploaded') as FormArray;
  // };

  // removeAttachmentUploaded(i: number) {
  // this.timetable_link_uploaded().removeAt(i);
  // }

  documentAttachment_uploaded(): FormArray {
    return this.createForm.get('documentAttachment_uploaded') as FormArray;
  };

  removeAttachmentUploaded(i: number) {
    this.documentAttachment_uploaded().removeAt(i);
  }

  service_image_uploaded(): FormArray {
    return this.createForm.get('service_image_uploaded') as FormArray;
  };

  removeAttachmentUploaded1(i: number) {
    this.service_image_uploaded().removeAt(i);
  }



  public selectAttachment(event: any, index) {

    this.createForm.value.documentAttachment[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.documentAttachment[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }


  public selectAttachment1(event: any, index) {

    this.createForm.value.ex_document_link[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.ex_document_link[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }

  fileDesign() {
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  imagePreview(value) {

    this.imageLink = value;
    this.modalService.show(this.imagePreviewRef, { class: 'modal-lgs' });

  }




  // getData() {

  //   if (this.ID) 
  //   {
  //   this.mode = 'Edit';
  //   this.modalTitle = 'Edit Servicing';
  //   }
  //   else 
  //   {
  //   this.mode = 'Create';
  //   this.modalTitle = 'Create Servicing';
  //   }
  // }

  getData() {


    this.generalLang = this.langs;

    this.typeConfig = [
      { value: '1', text: 'English' },
      { value: '2', text: 'Italian' },
    ];


    this.cid = this.CID;
    this.tid = this.TID;
    this.mode = 'Create';
    this.modalTitle = this.generalLang.languageSelection;
    this.FormBuild();



  }


  onSubmit() {

    // console.log(this.createForm.value); return false;

    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

    //   console.log('test12'); return false;

    this.consultancyService.download_task(this.createForm.value).subscribe(
      res => {

        var file = new Blob([res], { type: 'application/pdf' });            
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);


        this.bsModalRef.hide();

        this.router.navigateByUrl('/test', { skipLocationChange: true })
        .then(() => {
          this.router.navigate([AppFrontRoutes.CONSULTANCY_VIEW + '/' + this.CID]);
        });

        // if (res.status) {
        //   this.generalService.notify_msg('success', res.msg);
        //   this.bsModalRef.hide();

        //   this.router.navigateByUrl('/test', { skipLocationChange: true })
        //     .then(() => {
        //       this.router.navigate([AppFrontRoutes.CONSULTANCY_VIEW + '/' + this.SID]);
        //     });
        // }
        // else {
        //   this.generalService.notify_msg('error', res.msg);
        //   this.bsModalRef.hide();
        // }

      }
    );

  }

  checkValue(val) {
    if (val == 'change') {
      $('#referdate').show();
    }
    else {
      $('#referdate').hide();
    }
  }

}
